import axios from "axios";
import { useCallback, useEffect, useState } from "react";

export const TOKEN_KEY = "alfaz_staff_token";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/pos` });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
api.interceptors.response.use((r) => r, (error) => {
  if (error.response?.status === 401) window.dispatchEvent(new Event("auth-expired"));
  return Promise.reject(error);
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Ralat berlaku. Cuba lagi.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export function useApi(path, params) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const key = JSON.stringify(params || {});
  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const r = await api.get(path, { params: JSON.parse(key) });
      setData(r.data);
    } finally {
      setLoading(false);
    }
  }, [path, key]);
  useEffect(() => {
    reload();
  }, [reload]);
  return { data, loading, reload, setData };
}
